<template>
  <div class="section">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/100`"><Icon icon="computer" />Antrag auf Ausbildungsförderung</router-link>
      <router-link to="/services/100/section-1">Personenbezogene Angaben</router-link>
    </Breadcrumb>
    <div class="section__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/services/100" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="personalData" color="detailed" class="hide-mobile"/>
          <Headline subline="Abschnitt 1" headline="Personenbezogene Angaben" />
        </div>
        <div class="headline-link__right hide-mobile">
          <div>
            <h3><b>02</b> / 07</h3>
            <div class="progress" title="Fortschritt">
              <div class="bar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs top-xs">
        <div class="section__content__left col-xs-12 col-md-8">

<!-- Ausbildungsstätte -->
          <h3 class="margin-bottom--20">1. Ausbildungsstätte</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <h6>Ich beantrage Ausbildungsförderung für den Besuch der/des</h6>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputAutocomplete name="university" :list="['Hochschule Augsburg', 'Universität Augsburg', 'Fachhochschule Sigmaringen', 'Hochschule Furtwangen', 'Universität Konstanz', 'Universität Marburg' ]" :hint="true" placeholder="Tippen um Vorschläge zu erhalten">
                  Ausbildungsstätte (Hochschule)
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">
                    Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich.
                    </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputAutocomplete>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputAutocomplete name="program" :list="['Interaktive Medien', 'Interaktive Mediensysteme', 'BWL', 'VWL', 'Wirtschaftsingenieurwesen', 'Kommunikationsdesign', 'Design- und Kommunikationsstrategie', 'Jura', 'Soziale Arbeit']" :hint="true" placeholder="Tippen um Vorschläge zu erhalten">
                  Klasse / Fachrichtung
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">
                    Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich.
                    </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputAutocomplete>
              </div>
            </div>

            <div class="radios row margin-bottom--30">
              <div class="col-xs-6 col-sm-3">
                <input type="radio" id="vollzeit" value="vollzeit" v-model="time">
                <label for="vollzeit">Vollzeit</label>
              </div>
              <div class="col-xs-6 col-sm-3">
                <input type="radio" id="teilzeit" value="teilzeit" v-model="time">
                <label for="teilzeit">Teilzeit</label>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 label-hint">
                <label for="name" class="label">Immatrikulationsbescheinigung</label>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">
                    Eine Vollzeitausbildung liegt vor, wenn die Ausbildung nach den Ausbildungsbestimmungen oder der allgemeinen Erfahrung einschließlich aller Unterrichtsstunden, der notwendigen Vorbereitungen und der notwendigen Praktika 40 Wochenstunden erfordert. An Hochschulen kann eine solche grundsätzlich angenommen werden, wenn im Durchschnitt pro Semester 30 ECTS-Leistungspunkte vergeben werden.
                    </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 margin-top--10">
                <div class="upload">
                  <div class="upload__top">
                    <Icon icon="fileAdd" />
                    <div class="upload__top__text">
                      <h6>Immatrikulationsbescheinigung hier ablegen / Datei auswählen</h6>
                      <p>Erlaubte Dateiformate: .PDF, .JPG, .DOC</p>
                    </div>
                  </div>
                  <div class="row center-xs">
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Eigene Dateien" @click.native="toggleFileModal"/>
                    </div>
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Aus Dokumentenbox" @click.native="toggleDocModal"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="radios row middle-xs margin-top--40">
              <div class="col-xs-12 label-hint margin-bottom--20">
                <h6>Ich habe bereits früher einen Antrag auf Ausbildungsförderung gestellt</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-6 col-sm-2">
                <input type="radio" id="no" value="no" v-model="nr">
                <label for="no">Nein</label>
              </div>
              <div class="col-xs-6 col-sm-4">
                <input type="radio" id="yes" value="yes" v-model="nr">
                <label for="yes">Ja, mit der Antragsnummer:</label>
              </div>
              <div class="col-xs-12 col-sm-6">
                <input type="text" placeholder="z.B. BA28472" />
              </div>
            </div>

          </div>

<!-- Angaben zur Person -->
          <h3 class="margin-bottom--20 margin-top--60">2. Angaben zur Person</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <h6>Personenbezogene Angaben</h6>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText v-if="activeUser" name="firstName" :value="activeUser.firstName" :autofill="true" placeholder="Vorname">
                  Vorname
                </inputText>
                <InputText v-else name="firstName" placeholder="Vorname">
                  Vorname
                </inputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText v-if="activeUser" name="lastName" :value="activeUser.lastName" :autofill="true" placeholder="Nachname">
                  Name (ggf. Geburtsname)
                </inputText>
                <InputText v-else name="lastName" placeholder="Nachname">
                  Name (ggf. Geburtsname)
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputAutocomplete name="birthplace" :list="['Augsburg', 'München', 'Ravensburg', 'Nürnberg', 'Regensburg', 'Berlin', 'Köln', 'Hamburg', 'Frankfurt', 'Dortmund']" :hint="true">
                  Geburtsort
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputAutocomplete>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText name="birthDate" type="date" placeholder="">
                  Geburtsdatum
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Ledig', 'Verheiratet', 'Eingetragene Partnerschaft']" :hint="true" placeholder="z.B. ledig">
                  Familienstand
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText name="taxid" :autofill="true" pattern=".{11}" value="67750231000" :hint="true" placeholder="11-stellig" errorMsg="Falscher Wert. 11-stellige Zahl erforderlich">
                  Steueridentifikationsnummer
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Hallo hallo</p>
                  </div>
                </InputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Deutsch', 'Britisch', 'Italienisch', 'Französich', 'Türkisch', 'Albanisch']" :hint="true" placeholder="z.B. ledig">
                  Familienstand
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Falls Sie Ausländer/in sind, legen Sie bitte Ihre gültigen Aufenthaltsdokumente in Kopie vor. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
            </div>
          </div>
          <div class="autofill-hint">
            <img src="../../assets/images/status/hint.svg">
            <p>Felder mit der Markierung <b>AUTOFILL</b> wurden automatisch mit den Daten aus Ihrem Bürgerkonto befüllt. Überprüfen Sie die Richtigkeit und korrigieren Sie ggf. die Eingabe. </p>
          </div>

<!-- Eltern -->
          <h3 class="margin-bottom--20 margin-top--60">3. Eltern</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <h6>Personenbezogene Angaben ihrer <u>Mutter</u></h6>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText name="firstName">
                  Vorname
                </inputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText name="lastName">
                  Name (ggf. Geburtsname)
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText name="birthDate" type="date">
                  Geburtsdatum
                </inputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText name="diedat" type="date" :hint="true">
                  Verstorben am
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Deutsch', 'Italienisch', 'Griechisch', 'Türkisch', 'Albanisch']" :hint="true">
                  Staatsangehörigkeit
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Ledig', 'Verheiratet', 'Eingetragene Partnerschaft']" :hint="true" placeholder="z.B. ledig">
                  Familienstand
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
            </div>

            <h6 class="margin-top--40">Personenbezogene Angaben ihres <u>Vaters</u></h6>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText name="firstName">
                  Vorname
                </inputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText name="lastName">
                  Name (ggf. Geburtsname)
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputText name="birthDate" type="date">
                  Geburtsdatum
                </inputText>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputText name="diedat" type="date" :hint="true">
                  Verstorben am
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Deutsch', 'Italienisch', 'Griechisch', 'Türkisch', 'Albanisch']" :hint="true">
                  Staatsangehörigkeit
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
              <div class="col-xs-12 col-sm-6">
                <InputSelect name="birthplace" :values="['Ledig', 'Verheiratet', 'Eingetragene Partnerschaft']" :hint="true" placeholder="z.B. ledig">
                  Familienstand
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </InputSelect>
              </div>
            </div>
          </div>

<!-- Wohnsitz -->
          <h3 class="margin-bottom--20 margin-top--60">4. Wohnsitz</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="col-xs-12 label-hint margin-bottom--20">
                <h6 for="name">Wohnhaft bei Ihren Eltern/einem Elternteil in häuslicher Gemeinschaft</h6>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </div>
              </div>
            <div class="row radios">
              <div class="col-xs-12 col-md-6">
                <input type="radio" id="yess" :value="false" v-model="home">
                <label for="yess">Ja, wohnhaft bei meinen Eltern/einem Elternteil</label>
              </div>
              <div class="col-xs-12 col-md-6">
                <input type="radio" id="noo" :value="true" v-model="home">
                <label for="noo">Nein, anderer Wohnsitz</label>
              </div>
            </div>
                <transition name="showcase" mode="out-in">
                  <div v-if="!home" key="showcase" class="row">
                    <div class="showcase col-xs-12">
                      <table>
                        <tr>
                          <td>Anschrift</td>
                          <td>Klinkerberg 14<br>86152 Augsburg<br></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div v-else key="key" class="margin-top--30 margin-bottom--40">
                    <div class="row">
                      <div class="col-xs-12">
                        <h6>Anschrift Ihres Wohnsitzes während dem geplanten Studium <span>(falls schon vorhanden)</span></h6>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 col-sm-6">
                        <InputText name="plz" type="number" pattern=".{5}" :hint="true" placeholder="5-stellig">
                          Postleitzahl
                          <div slot="hint">
                            <h6>Hinweis</h6>
                            <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                            <h6>Warum ist das wichtig?</h6>
                            <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                          </div>
                        </inputText>
                      </div>
                      <div class="col-xs-12 col-sm-6">
                        <InputAutocomplete name="plz" :list="['Augsburg', 'Freiburg', 'München', 'Hamburg', 'Köln', 'Berlin', 'Ravensburg', 'Frankfurt']" :hint="true">
                          Ort
                          <div slot="hint">
                            <h6>Hinweis</h6>
                            <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                            <h6>Warum ist das wichtig?</h6>
                            <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                          </div>
                        </InputAutocomplete>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12">
                        <InputAutocomplete name="street" :list="['Maximilianstraße', 'Musterstraße', 'Mustergasse', 'Hobelweg']" :hint="true">
                          Straße, Hausnummer
                          <div slot="hint">
                            <h6>Hinweis</h6>
                            <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                            <h6>Warum ist das wichtig?</h6>
                            <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                          </div>
                        </InputAutocomplete>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 margin-top--10">
                        <div class="upload">
                          <div class="upload__top">
                            <Icon icon="fileAdd" />
                            <div class="upload__top__text">
                              <h6>Immatrikulationsbescheinigung hier ablegen / Datei auswählen</h6>
                              <p>Erlaubte Dateiformate: .PDF, .JPG, .DOC</p>
                            </div>
                          </div>
                          <div class="row center-xs">
                            <div class="col-xs-12 col-sm-5">
                              <Button type="ghost" text="Eigene Dateien" @click.native="toggleFileModal"/>
                            </div>
                            <div class="col-xs-12 col-sm-5">
                              <Button type="ghost" text="Aus Dokumentenbox" @click.native="toggleDocModal"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>
                <div class="row">
                  <div class="col-xs-12">
                    <h6>Kontakt am Wohnsitz</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-md-6">
                    <InputText name="plz" type="email" :hint="true" placeholder="z.B. vorname.nachname@gmx.de">
                      E-Mail (Angabe empfohlen)
                      <div slot="hint">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                      </div>
                    </inputText>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <InputText name="plz" type="text" pattern="(0|\+33|\(\+33\)|\(\0033\)|0033) ?[1-79]([\.\- ]?\d\d){4}" :hint="true" placeholder="Mit Ländervorwahl (z.B. +49)">
                      Telefon (Angabe empfohlen)
                      <div slot="hint">
                        <h6>Hinweis</h6>
                        <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                        <h6>Warum ist das wichtig?</h6>
                        <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                      </div>
                    </inputText>
                  </div>
                </div>
          </div>

<!-- Versicherungen -->
          <h3 class="margin-bottom--20 margin-top--60">5. Versicherungen</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12">
                <h6>Angaben zur Krankenversicherung während Ihres geplanten Studiums</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputSelect name="insurance"  :values="['Gesetzlich familienversichert', 'Privat Krankenversichert']" :hint="true">
                  Art der Versicherung
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputSelect>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 label-hint">
                <label for="name" class="label">Bescheinigung der Krankenversicherung</label>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 margin-top--10">
                <div class="upload">
                  <div class="upload__top">
                    <Icon icon="fileAdd" />
                    <div class="upload__top__text">
                      <h6>Bescheinigung Ihrer Krankenversicherung hier ablegen / Datei auswählen</h6>
                      <p>Erlaubte Dateiformate: .PDF, .JPG, .DOC</p>
                    </div>
                  </div>
                  <div class="row center-xs">
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Eigene Dateien" @click.native="toggleFileModal"/>
                    </div>
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Aus Dokumentenbox" @click.native="toggleDocModal"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-top--40">
              <div class="col-xs-12">
                <h6>Angaben zur Pflegeversicherung während Ihres geplanten Studiums</h6>
              </div>
            </div>
            <div class="row radios">
              <div class="col-xs-12 margin-bottom--10"><label>Selbst beitragspflichtig pflegeversichert?</label></div>
              <div class="col-xs-6 col-md-3">
                <input type="radio" id="jup" :value="true" v-model="insurance">
                <label for="jup">Ja</label>
              </div>
              <div class="col-xs-6 col-md-3">
                <input type="radio" id="ne" :value="false" v-model="insurance">
                <label for="ne">Nein</label>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 label-hint">
                <label for="name" class="label">Bescheinigung der Pflegeversicherung</label>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 margin-top--10">
                <div class="upload">
                  <div class="upload__top">
                    <Icon icon="fileAdd" />
                    <div class="upload__top__text">
                      <h6>Bescheinigung Ihrer Pflegeversicherung hier ablegen / Datei auswählen</h6>
                      <p>Erlaubte Dateiformate: .PDF, .JPG, .DOC</p>
                    </div>
                  </div>
                  <div class="row center-xs">
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Eigene Dateien" @click.native="toggleFileModal"/>
                    </div>
                    <div class="col-xs-12 col-sm-5">
                      <Button type="ghost" text="Aus Dokumentenbox" @click.native="toggleDocModal"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- Kinder -->
          <h3 class="margin-bottom--20 margin-top--60">6. Kinder</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12">
                <h6>Angaben über Ihre Kinder</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="insurance" type="number" :hint="true" placeholder="1">
                  Anzahl Kinder (ohne Stief- und Pflegekinder)
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
            <div class="row margin-top--40">
              <div class="col-xs-12">
                <h6>1. Kind</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="first" type="text">
                  Vorname
                </inputText>
              </div>
              <div class="col-xs-12 col-md-6">
                <InputText name="last" type="text">
                  Nachname
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="birth" type="date" :hint="true">
                  Geburtsdatum
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
              <div class="col-xs-12 col-md-6">
                <div class="row radios">
                  <div class="col-xs-12 margin-bottom--10"><label>Wohnt in Ihrem Haushalt</label></div>
                  <div class="col-xs-12 col-md-6">
                    <input type="radio" id="babyyes" :value="false" v-model="baby">
                    <label for="babyyes">Ja</label>
                  </div>
                  <div class="col-xs-12 col-md-6">
                    <input type="radio" id="babyno" :value="true" v-model="baby">
                    <label for="babyno">Nein</label>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- Bankverbindungen -->
          <h3 class="margin-bottom--20 margin-top--60">7. Bankverbindung</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <div class="row">
              <div class="col-xs-12">
                <h6>Ihre Bankverbindung</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <InputText name="insurance" type="text" pattern=".{20}" :hint="true" placeholder="20-stellig, z.B. DE 10 20000 30000000000" errorMsg="Falscher Wert. 20-stellige IBAN erforderlich.">
                  IBAN
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="first" type="text" :disabled="true" :hint="true" placeholder="Wird durch IBAN befüllt">
                  BIC
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
              <div class="col-xs-12 col-md-6">
                <InputText name="last" type="text" :disabled="true" :hint="true" placeholder="Wird durch IBAN befüllt">
                  Kreditinstitut
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Hallo hallo</p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <InputText name="owner" type="text" :hint="true">
                  Kontoinhaber (sofern nicht Sie selbst)
                  <div slot="hint">
                    <h6>Hinweis</h6>
                    <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                    <h6>Warum ist das wichtig?</h6>
                    <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                  </div>
                </inputText>
              </div>
            </div>
          </div>

          
        </div>
        
        <Modal v-if="showFileModal" @closeModal="toggleFileModal" :outside="true">
          <Card padding="35px" class="modal-file">
            <Headline subline="Datenfeld bearbeiten" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>

        <Modal v-if="showDocModal" @closeModal="toggleDocModal" :outside="true">
          <Card padding="0px" class="modal-file">
            <div class="content">
              <div class="content__headline">
                <Icon icon="docBox" color="detailed" />
                <Headline subline="Bürgerkonto" headline="Ihre Dokumentenbox"/>
              </div>
              <div v-if="activeUser && folders && userDocs" class="docbox__bottom">
                <div v-for="folder in folders" :key="folder.id" @click="toggleDocModal" class="doc">
                  <Icon icon="folder" />
                  <p>{{ folder.name }}</p>
                  <div class="folder-size hide-mobile"><Icon icon="file"/>{{ folder.docs.length }} Dateien</div>
                </div>
                <div v-for="(doc, index) in userDocs" v-show="index < 5" :key="doc.id" @click="toggleDocModal" class="doc">
                  <Icon icon="file" />
                  <p :class="{'new' : !doc.seen}">{{ doc.name }}</p>
                  <span>Auswählen</span>
                </div>
              </div>
              <div v-else class="docbox--empty">
                <p class="margin-top--20 margin-bottom--20">Melden Sie sich bitte in Ihrem Bürgerkonto an, um Ihre Dokumente einsehen zu können.</p>
              </div>
            </div>
            <div class="autofill-hint">
              <img src="../../assets/images/status/hint.svg">
              <p>Dokumente aus Ihrer Bürgerkonto-Dokumentenbox können nur Sie einsehen. Keine Einrichtung der öffentlichen Verwaltung hat ohne Ihre Zustimmung Zugriff auf Ihre Dateien.</p>
            </div>  
          </Card>        
        </Modal>

        <!-- Sidebar -->
        <div class="section__content__sidebar col-xs-12 col-md-3">
          <div class="nav-element done"
            @click="activeField = 1"
            :class="{'selected' : activeField == 1}"
            >
            <p>01. Ausbildungsstätte</p>
            <div class="status"></div>
          </div>
          <div class="nav-element done"
            @click="activeField = 2"
            :class="{'selected' : activeField == 2}"
            >
            <p>02. Angaben zu Ihrer Person</p>
            <div class="status"></div>
          </div>
          <div class="nav-element error"
            @click="activeField = 3"
            :class="{'selected' : activeField == 3}"
            >
            <p>03. Eltern</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 4"
            :class="{'selected' : activeField == 4}"
            >
            <p>04. Wohnsitz</p>
            <div class="status"></div>
          </div>
          <div class="nav-element done"
            @click="activeField = 5"
            :class="{'selected' : activeField == 5}"
            >
            <p>05. Versicherungen</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 6"
            :class="{'selected' : activeField == 6}"
            >
            <p>06. Kinder</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 7"
            :class="{'selected' : activeField == 7}"
            >
            <p>07. Bankverbindungen</p>
            <div class="status"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser">
      <div class="wrapper">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <Button type="secondary" text="Vorheriger Abschnitt" :disabled="true"/>
              </div>
              <div class="col-xs-12 col-md-6">
                <Button type="secondary" text="Eingaben prüfen"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <router-link to="/services/100/section-2">
              <Button type="primary" text="Weiter zu Abschnitt 2"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';
import InputSelect from '../../components/formElements/InputSelect/InputSelect';
import InputAutocomplete from '../../components/formElements/InputAutocomplete/InputAutocomplete';


export default {
  name: 'Section1',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
    InputAutocomplete,
    InputSelect,
  },
  data() {
    return {
      showModal: false,
      showFileModal: false,
      showDocModal: false,
      activeField: 1,
      toggleAll: false,
      time: '',
      nr: '',
      home: false,
      insurance: false,
      baby: false,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      folders: 'documents/getAllFolders',
      userDocs: 'documents/getAllDocs',
    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleFileModal() {
      this.showFileModal = !this.showFileModal;
    },
    toggleDocModal() {
      this.showDocModal = !this.showDocModal;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Section.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Section/Section1.vue